import { Check } from 'lucide-react';
import DimensionBars from '@/components/ds/DimensionBars';
import { DEMO_AUDIT } from '@/pages/homeLandingContent';

/* ── Feature preview graphics ────────────────────────────────────────────────
 * Small, static, and made only of things this product actually produces. Each
 * is decorative — the card's h3 and paragraph carry the meaning — so they are
 * aria-hidden and contain no text a reader needs. */
export function FeaturePreview({ kind }) {
  if (kind === 'score') {
    return (
      <div className="uxa-feature-card__frame" aria-hidden="true">
        <DimensionBars scores={DEMO_AUDIT.scores} height={56} testId="feature-score-preview" />
      </div>
    );
  }
  if (kind === 'wins') {
    return (
      <div className="uxa-feature-card__frame" aria-hidden="true" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {['Add sticky header CTA', 'Raise contrast on labels'].map((w) => (
          <span key={w} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', border: '1px dashed var(--border-2)', borderRadius: 'var(--radius-field)' }}>
            <span className="uxa-price-tick" style={{ marginTop: 0 }}><Check size={12} /></span>
            <span style={{ fontSize: 14, fontWeight: 500 }}>{w}</span>
          </span>
        ))}
      </div>
    );
  }
  if (kind === 'sprints') {
    return (
      <div className="uxa-feature-card__frame" aria-hidden="true" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {[100, 64, 40].map((w, i) => (
          <span key={i} style={{ display: 'block' }}>
            <span style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'var(--type-dense-size)', fontWeight: 700 }}>
              <span>Sprint {i + 1}</span>
            </span>
            <span style={{ display: 'block', height: 6, borderRadius: 3, background: 'var(--track-empty)', marginTop: 6 }}>
              <span style={{ display: 'block', width: `${w}%`, height: '100%', borderRadius: 3, background: i === 0 ? 'var(--accent)' : 'var(--accent-soft)' }} />
            </span>
          </span>
        ))}
      </div>
    );
  }
  if (kind === 'impact') {
    return (
      <div className="uxa-feature-card__frame" aria-hidden="true" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {['NNGroup', 'Baymard', 'Mixpanel'].map((src) => (
          <span key={src} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 'var(--type-dense-size)', fontWeight: 500, color: 'var(--ink-2)' }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--accent)', flex: 'none' }} />
            {src}
          </span>
        ))}
      </div>
    );
  }
  if (kind === 'pdf') {
    return (
      <div className="uxa-feature-card__frame" aria-hidden="true" style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <span style={{ width: 52, height: 66, borderRadius: 6, background: 'var(--surface-panel)', border: '1px solid var(--border-2)', flex: 'none', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: 6, gap: 3 }}>
          <span style={{ height: 3, borderRadius: 2, background: 'var(--accent-soft)', width: '80%' }} />
          <span style={{ height: 3, borderRadius: 2, background: 'var(--track-empty)', width: '100%' }} />
          <span style={{ height: 3, borderRadius: 2, background: 'var(--track-empty)', width: '64%' }} />
        </span>
        <span style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
          <span style={{ fontSize: 14, fontWeight: 700 }}>UX_Audit_Report.pdf</span>
          <span style={{ fontSize: 'var(--type-dense-size)', fontWeight: 500, color: 'var(--ink-2)' }}>Shareable with your team</span>
        </span>
      </div>
    );
  }
  return (
    <div className="uxa-feature-card__frame" aria-hidden="true" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 12, borderBottom: '1px solid var(--border-1)' }}>
        <span style={{ width: 26, height: 26, borderRadius: 8, background: 'var(--accent)' }} />
        <span style={{ fontSize: 14, fontWeight: 700 }}>Your Agency</span>
        <span style={{ marginLeft: 'auto', fontSize: 'var(--type-dense-size)', fontWeight: 500, color: 'var(--ink-2)' }}>Client report</span>
      </span>
      <span style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
        <span style={{ height: 6, borderRadius: 3, background: 'var(--track-empty)', width: '100%' }} />
        <span style={{ height: 6, borderRadius: 3, background: 'var(--track-empty)', width: '82%' }} />
        <span style={{ height: 6, borderRadius: 3, background: 'var(--track-empty)', width: '60%' }} />
      </span>
    </div>
  );
}

export default FeaturePreview;
